import Design3D from "./Design3D";

export default Design3D;
